import { tss } from "tss-react/mui";

export const useStyles = tss.create(({ theme }) => ({
	root: {
		background: "rgba(117, 139, 183, 0.04);",
		padding: "80px 290px",
		[theme.breakpoints.down('md')]: {
			padding: "40px 16px",

		},

		"& h4": {
			fontWeight: 900,
			fontSize: 24,
			lineHeight: "24px",
			letterSpacing: "0.18px",
			marginBottom: 24,

		},
		"& h5": {
			fontWeight: 900,
			fontSize: 22,
			lineHeight: "24px",
			letterSpacing: "0.18px",
			marginBottom: 24,

		},
		"& p": {
			fontSize: 22,
			lineHeight: "32px",
			letterSpacing: "0.15px",
			marginBottom: 32,
			[theme.breakpoints.down('md')]: {
				fontSize: 18,
				lineHeight: "32px",

			}
		}
	},

	listOl: {
		listStyle: "lower-roman",
		paddingInlineStart: 80,
		marginBottom: 32,
		"& p, li": {
			fontSize: 22,
			lineHeight: "32px",
			letterSpacing: "0.15px",
		},
		[theme.breakpoints.down('md')]: {
			paddingInlineStart: 40,
			marginBottom: 32,
			"& p, li": {
				fontSize: 18,
				lineHeight: "32px",
				letterSpacing: "0.18px",
			},

		}
	},
	sublistOl: {
		paddingInlineStart: 80,
		marginBottom: 32,
		"& p, li": {
			fontSize: 22,
			lineHeight: "32px",
			letterSpacing: "0.15px",
		},
		[theme.breakpoints.down('md')]: {
			paddingInlineStart: 50,
			marginBottom: 32,
			"& p, li": {
				fontSize: 18,
				lineHeight: "32px",
				letterSpacing: "0.18px",
			},

		}
	},
	padding: {
		paddingLeft: 50,
	}
}))